import PropTypes from 'prop-types'

export default function CheckOutlined({ stroke = '#B91D7B' }) {
  return (
    <svg width="33.33" height="33.33" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4982 19.9997L17.4982 24.9997L27.4982 14.9997M36.6649 19.9997C36.6649 29.2044 29.203 36.6663 19.9982 36.6663C10.7935 36.6663 3.33154 29.2044 3.33154 19.9997C3.33154 10.7949 10.7935 3.33301 19.9982 3.33301C29.203 3.33301 36.6649 10.7949 36.6649 19.9997Z"
        stroke={stroke}
        strokeWidth="2.85714"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

CheckOutlined.propTypes = {
  stroke: PropTypes.string,
}
